var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAsyncAutocomplete',_vm._g(_vm._b({ref:"autocomplete",attrs:{"item-text":"name","item-value":"id","label":"Участник","no-data-text":"Участник не найден","request":_vm.request}},'BAsyncAutocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }